import gql from 'graphql-tag';


// Example PK: "ShipmentNo#660889#CARRIERID#605882"
// Example SK: "DeliveryNo#ORIGINAL#8130264316#LID#337729"
export const GetDocketPdfUrl = gql`
  mutation generateeDocketResponse($shipmentId: String!, $carrierId: String!) {
  generateeDocketResponse(shipmentId: $shipmentId, carrierId: $carrierId) {
    message
    files_copied
    presigned_urls {
      filename  
      url
      expires_in_minutes
    }
  }
}
`;

/**
 * Get a presigned URLs to download the PDF for a delivery docket
 * @param {*} graphClient AWS Graph Client
 * @param {*} shipmentId Shipment ID
 * @param {*} carrierId Carrier ID
 * @returns Presigned S3 URLs for PDF download
 */
export const getDocketPdfUrl = async (graphClient, shipmentId, carrierId) => {
  try {
    let response = await graphClient.mutate({
      mutation: GetDocketPdfUrl,
      variables: {
        shipmentId: shipmentId,
        carrierId: carrierId,
      },
      fetchPolicy: 'no-cache',
    });
    return response;
  } catch (e) {
    console.log('Error! while register: generateeDocketResponse', e);
    return { error: e.message };
  }
};